// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: rgb(175, 44, 48);
    padding-left: 200px;
    padding-right: 200px;
    padding-top: 20px;
    padding-bottom: 20px;
}
.navbar.bottom{
    background-color: #FFFF;
}

.navbar__logo {
    display: flex;
    align-items: end;
    justify-content: center;
}

.navbar__logo p {
    letter-spacing: 0.01em;
    color: #EEF1E5;
    font-size: 16px;
    line-height: 1.3em;
    margin-left: 30px;
}

.navbar__user {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.navbar__user svg {
    font-size: 40px;
    color: #EEF1E5;
}

.navbar__user p {
    letter-spacing: 0.01em;
    color: #EEF1E5;
    font-size: 16px;
    line-height: 1.3em;
}

.search{
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    border: 1px solid #AF2C30;
    overflow: hidden;
}
.search input{
    width: 100%;
    padding-left: 20px;
    outline: none;
    height: 40px;
    border: none;
}
.search__button{
    width: 50px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #AF2C30;
}
.search__button svg{
    font-size: 25px;
    color: #FFF;
}

@media(max-width:991px) {
    .navbar {
        padding-left: 50px;
        padding-right: 50px;
    }
}

@media(max-width: 750px) {
    .navbar {
        padding-left: 15px;
        padding-right: 15px;
    }
    .navbar__logo {
        display: flex;
        flex-wrap: wrap;
        justify-content: start;
        gap: 10px;
    }
    .navbar__logo p{
        margin-left: 0px;
    }
    
    .navbar__logo > * {
        flex: 10% 1 45%;
    }
    .navbar__logo img{
        width: 20%;
    }
    .navbar.bottom{
        flex-direction: column;
        gap: 10px;
    }
    .navbar.bottom .btn{
        width: 100%;
        max-width: 400px;
    }
    .navbar.bottom .search{
        max-width: 400px;
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/navbar/navbar.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kCAAkC;IAClC,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,aAAa;QACb,eAAe;QACf,sBAAsB;QACtB,SAAS;IACb;IACA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAiB;IACrB;IACA;QACI,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,SAAS;IACb;IACA;QACI,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,gBAAgB;QAChB,WAAW;IACf;AACJ","sourcesContent":[".navbar {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    background-color: rgb(175, 44, 48);\r\n    padding-left: 200px;\r\n    padding-right: 200px;\r\n    padding-top: 20px;\r\n    padding-bottom: 20px;\r\n}\r\n.navbar.bottom{\r\n    background-color: #FFFF;\r\n}\r\n\r\n.navbar__logo {\r\n    display: flex;\r\n    align-items: end;\r\n    justify-content: center;\r\n}\r\n\r\n.navbar__logo p {\r\n    letter-spacing: 0.01em;\r\n    color: #EEF1E5;\r\n    font-size: 16px;\r\n    line-height: 1.3em;\r\n    margin-left: 30px;\r\n}\r\n\r\n.navbar__user {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 10px;\r\n}\r\n\r\n.navbar__user svg {\r\n    font-size: 40px;\r\n    color: #EEF1E5;\r\n}\r\n\r\n.navbar__user p {\r\n    letter-spacing: 0.01em;\r\n    color: #EEF1E5;\r\n    font-size: 16px;\r\n    line-height: 1.3em;\r\n}\r\n\r\n.search{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 10px;\r\n    border: 1px solid #AF2C30;\r\n    overflow: hidden;\r\n}\r\n.search input{\r\n    width: 100%;\r\n    padding-left: 20px;\r\n    outline: none;\r\n    height: 40px;\r\n    border: none;\r\n}\r\n.search__button{\r\n    width: 50px;\r\n    height: 40px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: #AF2C30;\r\n}\r\n.search__button svg{\r\n    font-size: 25px;\r\n    color: #FFF;\r\n}\r\n\r\n@media(max-width:991px) {\r\n    .navbar {\r\n        padding-left: 50px;\r\n        padding-right: 50px;\r\n    }\r\n}\r\n\r\n@media(max-width: 750px) {\r\n    .navbar {\r\n        padding-left: 15px;\r\n        padding-right: 15px;\r\n    }\r\n    .navbar__logo {\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        justify-content: start;\r\n        gap: 10px;\r\n    }\r\n    .navbar__logo p{\r\n        margin-left: 0px;\r\n    }\r\n    \r\n    .navbar__logo > * {\r\n        flex: 10% 10% 45%;\r\n    }\r\n    .navbar__logo img{\r\n        width: 20%;\r\n    }\r\n    .navbar.bottom{\r\n        flex-direction: column;\r\n        gap: 10px;\r\n    }\r\n    .navbar.bottom .btn{\r\n        width: 100%;\r\n        max-width: 400px;\r\n    }\r\n    .navbar.bottom .search{\r\n        max-width: 400px;\r\n        width: 100%;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
